module.exports = __webpack_public_path__ + "media/home/SeeUsInMotion-x2-48f97a91.png";